import Vue from 'vue';

const success = (data, resolve) => {
  const result = {
    errors: data.errors,
    data,
  };
  resolve(result);
};

const failed = (error, reject) => reject(error);

export default ids => (
  new Promise((resolve, reject) => {
    Vue.$http.delete(`/orders/cancel?order_ids=${ids}`)
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/order/bulkCancel.js